import { createElement, memo } from 'react';

type TextProps = {
  lKey: string;
  domElement?: string;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
};

export const Text = memo((props: TextProps) => {
  const { lKey, domElement = 'span', className, onClick } = props;

  return createElement(domElement, {
    className,
    onClick,
    dangerouslySetInnerHTML: { __html: lKey },
  });
});

Text.displayName = 'Text';